module.exports = __webpack_public_path__ + "img/bg2017-min.a68e761f.jpg";